import RoundMiniIcon from '@components/atoms/RoundMiniIcon/RoundMiniIcon'
import PropTypes from 'prop-types'
import { useState } from 'react'
import c from 'classnames'
import { useSelector } from 'react-redux'
import styles from './ProductInfo.module.scss'
import IconLink from '@components/atoms/IconLink/IconLink'
import Translate from '@components/atoms/Translate/Translate'
import Text from '@components/atoms/Text/Text'
import { getSujetDimensionsByCoordinates } from '@utils/sujetHelpers'

import { sendEvent } from '@utils/tracking'

// available props: bright
const ProductInfo = () => {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const { selectedSujet } = useSelector((state) => state.app)
  const gtmEvent = {
    productDetail: {
      name: 'Sujet testen - Clickout Produktdetail',
      category: 'sujet testen',
      action: 'Clickout Produktdetail',
    },
    productRequest: {
      name: 'Sujet testen - Anfrage',
      category: 'sujet testen',
      action: 'Click auf Anfrage',
    },
  }

  const toggleCollapsed = () => {
    setIsCollapsed((old) => !old)
  }

  if (!selectedSujet) {
    return null
  }
  const dimensions = getSujetDimensionsByCoordinates(
    selectedSujet?.images?.day?.coordinates
  )

  return (
    <div
      className={c(styles.base, {
        [styles.collapsed]: isCollapsed,
      })}
    >
      <div className="o-grid">
        <div className={`o-grid__col u-${isCollapsed ? 4 : 6}/6@md`}>
          <div className={styles.container}>
            <div className={styles.collapseIcon} onClick={toggleCollapsed}>
              <RoundMiniIcon icon="arrow-right" />
            </div>

            <div className={styles.image}>
              <img src={selectedSujet.thumbnail} />
            </div>

            <div
              className={c(styles.info, {
                // 'b-lightGrey': bright,
                // 'b-midGrey': !bright,
              })}
            >
              <div className={styles.name}>
                <Text type="text-l" bold>
                  {selectedSujet.title}
                </Text>
              </div>

              <div className={styles.description}>
                <Text type="text-xs">{selectedSujet.description}</Text>
                <br />
                <Text type="text-xs">
                  Mindestgröße der Datei in Pixel: {dimensions.aspectRatio}
                </Text>
              </div>

              <div className={styles.links}>
                <div
                  className={styles.link}
                  onClick={() =>
                    sendEvent(
                      gtmEvent.productDetail.name,
                      gtmEvent.productDetail.category,
                      gtmEvent.productDetail.action
                    )
                  }
                >
                  <IconLink
                    icon="arrow-long-right"
                    href={selectedSujet.productLink}
                    target="_blank"
                  >
                    <Translate str="steps.upload.info.toProduct" />
                  </IconLink>
                </div>

                <div
                  className={styles.link}
                  onClick={() =>
                    sendEvent(
                      gtmEvent.productRequest.name,
                      gtmEvent.productRequest.category,
                      gtmEvent.productRequest.action
                    )
                  }
                >
                  <IconLink
                    icon="mail"
                    href={`mailto:${selectedSujet.contact}`}
                  >
                    <Translate str="steps.upload.info.request" />
                  </IconLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ProductInfo.defaultProps = {
  bright: false,
}
ProductInfo.propTypes = { bright: PropTypes.bool }

export default ProductInfo
